module.exports = __webpack_public_path__ + "static/media/chat_nav.603f602f.svg";